/**
 * The single source of truth for SQE-specific portal behavior.
 * When employee-based checks are required, change this implementation only.
 */
export function isSqeLabsContext(): boolean {
  return String(process.env.REACT_APP_COMPANY_NAME ?? "")
    .trim()
    .toUpperCase() === "SQE";
}

// Keep older imports working while the development compiler refreshes modules.
export const isSqeLabsPortal = isSqeLabsContext;

export function useSqeLabs(): boolean {
  return isSqeLabsContext();
}
